
// @ts-nocheck
import locale_af_46json_639f90b3 from "#nuxt-i18n/639f90b3";
import locale_ar_46json_0e430d9f from "#nuxt-i18n/0e430d9f";
import locale_bg_46json_c6c25a60 from "#nuxt-i18n/c6c25a60";
import locale_ca_46json_378d9f26 from "#nuxt-i18n/378d9f26";
import locale_cs_46json_7b6cd88f from "#nuxt-i18n/7b6cd88f";
import locale_da_46json_895cb340 from "#nuxt-i18n/895cb340";
import locale_de_46json_a97cacc2 from "#nuxt-i18n/a97cacc2";
import locale_dum_46json_146aa90c from "#nuxt-i18n/146aa90c";
import locale_el_46json_9cb64aa4 from "#nuxt-i18n/9cb64aa4";
import locale_en_46json_4076254c from "#nuxt-i18n/4076254c";
import locale_es_46json_709470d2 from "#nuxt-i18n/709470d2";
import locale_fi_46json_b1952cf6 from "#nuxt-i18n/b1952cf6";
import locale_fr_46json_76d14f8d from "#nuxt-i18n/76d14f8d";
import locale_he_46json_bd278a76 from "#nuxt-i18n/bd278a76";
import locale_hu_46json_e2880838 from "#nuxt-i18n/e2880838";
import locale_it_46json_3c7045ce from "#nuxt-i18n/3c7045ce";
import locale_ja_46json_6a9f3afd from "#nuxt-i18n/6a9f3afd";
import locale_ko_46json_02195f12 from "#nuxt-i18n/02195f12";
import locale_ku_46json_6c5b0fae from "#nuxt-i18n/6c5b0fae";
import locale_nl_46json_d59ff566 from "#nuxt-i18n/d59ff566";
import locale_no_46json_2881ce40 from "#nuxt-i18n/2881ce40";
import locale_pl_46json_308ced35 from "#nuxt-i18n/308ced35";
import locale_pt_46json_a6be18bf from "#nuxt-i18n/a6be18bf";
import locale_ro_46json_ee405647 from "#nuxt-i18n/ee405647";
import locale_ru_46json_6f3023ab from "#nuxt-i18n/6f3023ab";
import locale_sr_46json_9932f665 from "#nuxt-i18n/9932f665";
import locale_sv_46json_521d3f52 from "#nuxt-i18n/521d3f52";
import locale_tr_46json_65dd7f9d from "#nuxt-i18n/65dd7f9d";
import locale_uk_46json_3f4778ac from "#nuxt-i18n/3f4778ac";
import locale_zh_hans_46json_e82d3f51 from "#nuxt-i18n/e82d3f51";
import locale_zh_hant_46json_f1ebeeb3 from "#nuxt-i18n/f1ebeeb3";

export const localeCodes =  [
  "af",
  "ar",
  "bg",
  "ca",
  "cs",
  "da",
  "de",
  "dum",
  "el",
  "en",
  "es",
  "fi",
  "fr",
  "he",
  "hu",
  "it",
  "ja",
  "ko",
  "ku",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "ru",
  "srcyrl",
  "sv",
  "tr",
  "uk",
  "zhS",
  "zhT"
]

export const localeLoaders = {
  af: [
    {
      key: "locale_af_46json_639f90b3",
      load: () => Promise.resolve(locale_af_46json_639f90b3),
      cache: true
    }
  ],
  ar: [
    {
      key: "locale_ar_46json_0e430d9f",
      load: () => Promise.resolve(locale_ar_46json_0e430d9f),
      cache: true
    }
  ],
  bg: [
    {
      key: "locale_bg_46json_c6c25a60",
      load: () => Promise.resolve(locale_bg_46json_c6c25a60),
      cache: true
    }
  ],
  ca: [
    {
      key: "locale_ca_46json_378d9f26",
      load: () => Promise.resolve(locale_ca_46json_378d9f26),
      cache: true
    }
  ],
  cs: [
    {
      key: "locale_cs_46json_7b6cd88f",
      load: () => Promise.resolve(locale_cs_46json_7b6cd88f),
      cache: true
    }
  ],
  da: [
    {
      key: "locale_da_46json_895cb340",
      load: () => Promise.resolve(locale_da_46json_895cb340),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_a97cacc2",
      load: () => Promise.resolve(locale_de_46json_a97cacc2),
      cache: true
    }
  ],
  dum: [
    {
      key: "locale_dum_46json_146aa90c",
      load: () => Promise.resolve(locale_dum_46json_146aa90c),
      cache: true
    }
  ],
  el: [
    {
      key: "locale_el_46json_9cb64aa4",
      load: () => Promise.resolve(locale_el_46json_9cb64aa4),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_4076254c",
      load: () => Promise.resolve(locale_en_46json_4076254c),
      cache: true
    }
  ],
  es: [
    {
      key: "locale_es_46json_709470d2",
      load: () => Promise.resolve(locale_es_46json_709470d2),
      cache: true
    }
  ],
  fi: [
    {
      key: "locale_fi_46json_b1952cf6",
      load: () => Promise.resolve(locale_fi_46json_b1952cf6),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_76d14f8d",
      load: () => Promise.resolve(locale_fr_46json_76d14f8d),
      cache: true
    }
  ],
  he: [
    {
      key: "locale_he_46json_bd278a76",
      load: () => Promise.resolve(locale_he_46json_bd278a76),
      cache: true
    }
  ],
  hu: [
    {
      key: "locale_hu_46json_e2880838",
      load: () => Promise.resolve(locale_hu_46json_e2880838),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_3c7045ce",
      load: () => Promise.resolve(locale_it_46json_3c7045ce),
      cache: true
    }
  ],
  ja: [
    {
      key: "locale_ja_46json_6a9f3afd",
      load: () => Promise.resolve(locale_ja_46json_6a9f3afd),
      cache: true
    }
  ],
  ko: [
    {
      key: "locale_ko_46json_02195f12",
      load: () => Promise.resolve(locale_ko_46json_02195f12),
      cache: true
    }
  ],
  ku: [
    {
      key: "locale_ku_46json_6c5b0fae",
      load: () => Promise.resolve(locale_ku_46json_6c5b0fae),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_d59ff566",
      load: () => Promise.resolve(locale_nl_46json_d59ff566),
      cache: true
    }
  ],
  no: [
    {
      key: "locale_no_46json_2881ce40",
      load: () => Promise.resolve(locale_no_46json_2881ce40),
      cache: true
    }
  ],
  pl: [
    {
      key: "locale_pl_46json_308ced35",
      load: () => Promise.resolve(locale_pl_46json_308ced35),
      cache: true
    }
  ],
  pt: [
    {
      key: "locale_pt_46json_a6be18bf",
      load: () => Promise.resolve(locale_pt_46json_a6be18bf),
      cache: true
    }
  ],
  ro: [
    {
      key: "locale_ro_46json_ee405647",
      load: () => Promise.resolve(locale_ro_46json_ee405647),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_6f3023ab",
      load: () => Promise.resolve(locale_ru_46json_6f3023ab),
      cache: true
    }
  ],
  srcyrl: [
    {
      key: "locale_sr_46json_9932f665",
      load: () => Promise.resolve(locale_sr_46json_9932f665),
      cache: true
    }
  ],
  sv: [
    {
      key: "locale_sv_46json_521d3f52",
      load: () => Promise.resolve(locale_sv_46json_521d3f52),
      cache: true
    }
  ],
  tr: [
    {
      key: "locale_tr_46json_65dd7f9d",
      load: () => Promise.resolve(locale_tr_46json_65dd7f9d),
      cache: true
    }
  ],
  uk: [
    {
      key: "locale_uk_46json_3f4778ac",
      load: () => Promise.resolve(locale_uk_46json_3f4778ac),
      cache: true
    }
  ],
  zhS: [
    {
      key: "locale_zh_hans_46json_e82d3f51",
      load: () => Promise.resolve(locale_zh_hans_46json_e82d3f51),
      cache: true
    }
  ],
  zhT: [
    {
      key: "locale_zh_hant_46json_f1ebeeb3",
      load: () => Promise.resolve(locale_zh_hant_46json_f1ebeeb3),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/3432c363" /* webpackChunkName: "config_i18n_46config_46ts_3432c363" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: true,
    fullInstall: true,
    dropMessageCompiler: true,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "af",
      name: "Afrikaans",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/af.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ar",
      name: "Arabic",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ar.json",
          cache: undefined
        }
      ]
    },
    {
      code: "bg",
      name: "Bulgarian (Български)",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/bg.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ca",
      name: "Catalan",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ca.json",
          cache: undefined
        }
      ]
    },
    {
      code: "cs",
      name: "Czech",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/cs.json",
          cache: undefined
        }
      ]
    },
    {
      code: "da",
      name: "Danish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/da.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "dum",
      name: "In-Context Editor",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/dum.json",
          cache: undefined
        }
      ]
    },
    {
      code: "el",
      name: "Greek",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/el.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "es",
      name: "Español",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/es.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fi",
      name: "Finnish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/fi.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "he",
      name: "Hebrew",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/he.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hu",
      name: "Hungarian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/hu.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italiano",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ja",
      name: "Japanese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ja.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ko",
      name: "Korean",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ko.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ku",
      name: "Kurdish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ku.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      name: "Nederlands",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/nl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "no",
      name: "Norsk",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/no.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pl",
      name: "Polish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/pl.json",
          cache: undefined
        }
      ]
    },
    {
      code: "pt",
      name: "Portugese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/pt.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ro",
      name: "Romanian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ro.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Russian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ru.json",
          cache: undefined
        }
      ]
    },
    {
      code: "srcyrl",
      name: "Serbian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/sr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "sv",
      name: "Swedish",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/sv.json",
          cache: undefined
        }
      ]
    },
    {
      code: "tr",
      name: "Türkçe",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/tr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "uk",
      name: "Ukrainian",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/uk.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zhS",
      name: "Simplified Chinese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/zh_hans.json",
          cache: undefined
        }
      ]
    },
    {
      code: "zhT",
      name: "Traditional Chinese",
      files: [
        {
          path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/zh_hant.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "../app/i18n/locales/processed",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "af",
    name: "Afrikaans",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/af.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ar",
    name: "Arabic",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ar.json",
        cache: undefined
      }
    ]
  },
  {
    code: "bg",
    name: "Bulgarian (Български)",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/bg.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ca",
    name: "Catalan",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ca.json",
        cache: undefined
      }
    ]
  },
  {
    code: "cs",
    name: "Czech",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "da",
    name: "Danish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/da.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "dum",
    name: "In-Context Editor",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/dum.json",
        cache: undefined
      }
    ]
  },
  {
    code: "el",
    name: "Greek",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/el.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "es",
    name: "Español",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/es.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fi",
    name: "Finnish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/fi.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "he",
    name: "Hebrew",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/he.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hu",
    name: "Hungarian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/hu.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italiano",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ja",
    name: "Japanese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ja.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ko",
    name: "Korean",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ko.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ku",
    name: "Kurdish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ku.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    name: "Nederlands",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/nl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "no",
    name: "Norsk",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/no.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pl",
    name: "Polish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/pl.json",
        cache: undefined
      }
    ]
  },
  {
    code: "pt",
    name: "Portugese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/pt.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ro",
    name: "Romanian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ro.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Russian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/ru.json",
        cache: undefined
      }
    ]
  },
  {
    code: "srcyrl",
    name: "Serbian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/sr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "sv",
    name: "Swedish",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/sv.json",
        cache: undefined
      }
    ]
  },
  {
    code: "tr",
    name: "Türkçe",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/tr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "uk",
    name: "Ukrainian",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/uk.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zhS",
    name: "Simplified Chinese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/zh_hans.json",
        cache: undefined
      }
    ]
  },
  {
    code: "zhT",
    name: "Traditional Chinese",
    files: [
      {
        path: "/home/runner/work/Hangar/Hangar/frontend/app/i18n/locales/processed/zh_hant.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/